import type { FaireProductEntity } from "../../entity_types/product";

export const p_ehtht010: FaireProductEntity = {
  token: "p_ehtht010",
  type: "product",
  name: "Camper Love Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/res/hszgttpjt/image/upload/df0cecf84f6aead6375684d59621b746c8c1abe76902ea698bb863289c257463/1528360514.png",
  galleryImageUrls: [
    "https://cdn.faire.com/res/hszgttpjt/image/upload/378eb6c170cf3ab60005a2d5db1044ea1690bfe27733ccfe69e60bfe9214649c/1528360513.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:49.135Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
